module.exports = __webpack_public_path__ + "img/mac_mobile_kz.fe358aca.png";